module.exports = __webpack_public_path__ + "img/empty.565c5b8e.png";